import { render, staticRenderFns } from "./ViolationNewForm.vue?vue&type=template&id=63911b38"
import script from "./ViolationNewForm.vue?vue&type=script&lang=js"
export * from "./ViolationNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports